import fs from "fs";
import { Box, Text } from "@mantine/core";
import { serialize } from "next-mdx-remote/serialize";
import imageSize from "rehype-img-size";
import Image from "next/image";
import { MDXRemote } from "next-mdx-remote";
import rehypeHighlight from "rehype-highlight";
import Seo from "../../components/SEO";

const components = {
  img: (props) => (
    // height and width are part of the props, so they get automatically passed here with {...props}
    <Image {...props} alt={props.alt} layout="responsive" loading="lazy" />
  ),
  a: (props) => (
    <Text {...props} component="a" color="blue">
      {props.children}
    </Text>
  ),
  //   a: (props) => <Text as="a" {...props} />,
};

export async function getStaticPaths() {
  const files = fs.readdirSync("blog");
  const paths = files.map((fileName) => ({
    params: {
      slug: fileName.replace(".md", ""),
    },
  }));
  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ params: { slug } }) {
  const fileName = fs.readFileSync(`blog/${slug}.md`, "utf-8");
  //   const { data: frontmatter, content } = matter(fileName);
  const mdxSource = await serialize(fileName, {
    parseFrontmatter: true,
    mdxOptions: {
      // use the image size plugin, you can also specify which folder to load images from
      // in my case images are in /public/images/, so I just prepend 'public'
      rehypePlugins: [[imageSize, { dir: "public" }], rehypeHighlight],
    },
  });
  return {
    props: {
      mdxSource,
    },
  };
}

export default function BlogPage({ mdxSource }) {
  return (
    <Box>
      <Seo title={`${mdxSource.frontmatter.title}`} description={`${mdxSource.frontmatter.description}`} />
      <header>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.4.0/styles/github-dark.min.css"></link>
      </header>
      <h1>{mdxSource.frontmatter.title}</h1>
      <MDXRemote {...mdxSource} components={components} />
    </Box>
  );
}
